import * as React from "react";

import { registerLWPComponent } from "VSS/LWP";

import { IItem } from "Presentation/Scripts/TFS/Stores/TreeStore";
import { GitRepository } from "TFS/VersionControl/Contracts";
import { FilesTree } from "VersionControl/Scenarios/Shared/FilesTree";
import { GitRepositoryContext } from "VersionControl/Scripts/GitRepositoryContext";
import { GitBranchVersionSpec } from "VersionControl/Scripts/TFS.VersionControl.VersionSpecs";

import "VSS/LoaderPlugins/Css!Wiki/Scenarios/Integration/FilePicker/FilePicker";


export interface WikiFilesTreeNwpWrapperProps {
    repository: GitRepository;
    selectedFullPath: string;
    branchName: string;
    onItemSelected(path: string): void;
    onError(error: Error): void;
}

export class WikiFilesTreeNwpWrapper extends React.PureComponent<WikiFilesTreeNwpWrapperProps, {}> {
    public static componentType = "WikiFilesTreeNwpWrapper";
    private _repositoryContext: GitRepositoryContext;
    private _versionSpec: GitBranchVersionSpec;

    constructor(props: WikiFilesTreeNwpWrapperProps) {
        super(props);
        this._repositoryContext = GitRepositoryContext.create(this.props.repository);
        this._versionSpec = new GitBranchVersionSpec(this.props.branchName);
    }
    
    public render(): JSX.Element {
        return (
        // Following classnames are applied for legacy styles
        <div className="file-picker-dialog">
            <div className="file-picker">
                <FilesTree
                    repositoryContext={this._repositoryContext}
                    selectedFullPath={this.props.selectedFullPath}
                    versionSpec={this._versionSpec}
                    onItemSelected={this.props.onItemSelected}
                    onError={this.props.onError}
                    getItemHasCommands={this._getItemHasCommands}
                    getItemIsDisabled={this._getItemIsDisabled}
                />
            </div>
        </div>);
    }

    private _getItemHasCommands = () => false;

    private _getItemIsDisabled = (item: IItem): boolean => {
        return !item.isFolder;
    }
}

registerLWPComponent(WikiFilesTreeNwpWrapper.componentType, WikiFilesTreeNwpWrapper);
